// Date de mise en circulation (MEC) d'un véhicule. Le champ `mec` a deux formes en base :
// une ANNÉE seule (2019 — anciens imports, ancienne recherche ServiceBox) ou des secondes
// Unix (sélecteur de date, recherche ServiceBox actuelle). Une année seule n'est pas une
// date : on ne l'affiche pas comme le 01/01/1970 et on ne l'envoie pas à ServiceBox.
// Miroir de app/services/vehicle_mec.py (backend) — les garder alignés.

const YEAR_MAX = 10000;

const parisParts = new Intl.DateTimeFormat("fr-FR", {
  timeZone: "Europe/Paris",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function isMecYearOnly(mec?: number | null): boolean {
  return typeof mec === "number" && mec > 0 && mec < YEAR_MAX;
}

/** Vrai quand `mec` porte un jour précis (secondes). */
export function isMecFullDate(mec?: number | null): mec is number {
  return typeof mec === "number" && Number.isFinite(mec) && mec !== 0 && !isMecYearOnly(mec);
}

/** Jour de MEC à Paris en { day: "dd", month: "mm", year: "yyyy" }, ou null (vide / année seule). */
export function mecParts(mec?: number | null): { day: string; month: string; year: string } | null {
  if (!isMecFullDate(mec)) return null;
  const parts = parisParts.formatToParts(new Date(mec * 1000));
  const get = (type: string) => parts.find((p) => p.type === type)?.value || "";
  const day = get("day");
  const month = get("month");
  const year = get("year");
  return day && month && year ? { day, month, year } : null;
}

/** Libellé du sélecteur de date : une année seule n'a pas de jour à montrer, on la cite. */
export function mecPickerLabel(mec?: number | null, label = "MEC"): string {
  return isMecYearOnly(mec) ? `${label} (${mec})` : label;
}
